import { __decorate } from "tslib";
import { NgModule } from '@angular/core';
let SailsSocketModule = class SailsSocketModule {
};
SailsSocketModule = __decorate([
    NgModule({})
], SailsSocketModule);
export { SailsSocketModule };
